/** Genius public routes inside inmobius (genius /home = main landing). */
export const GENIUS_ROUTES = Object.freeze({
  HOME: "/home",
  SCHOOL_LOGIN: "/school-login",
  SCHOOL_REGISTER: "/school-register",
  OLYMPIAD: "/olympiad",
  OLYMPIAD_SCORE: "/olympiad/score",
  OLYMPIAD_MATH: "/olympiad/math",
  OLYMPIAD_HOTS: "/olympiad/hots",
  TESTIMONIALS: "/testimonials",
  HOW_IT_WORKS: "/how-it-works",
  ABOUT: "/about",
  CHAMPIONS: "/champions",
  NOT_FOUND: "/genius-not-found"
});

const GENIUS_ROUTE_PATHS = [
  GENIUS_ROUTES.HOME,
  GENIUS_ROUTES.SCHOOL_REGISTER,
  GENIUS_ROUTES.SCHOOL_LOGIN,
  GENIUS_ROUTES.OLYMPIAD_MATH,
  GENIUS_ROUTES.OLYMPIAD_SCORE,
  GENIUS_ROUTES.OLYMPIAD_HOTS,
  GENIUS_ROUTES.TESTIMONIALS,
  GENIUS_ROUTES.HOW_IT_WORKS,
  GENIUS_ROUTES.ABOUT,
  GENIUS_ROUTES.CHAMPIONS,
  GENIUS_ROUTES.OLYMPIAD,
  GENIUS_ROUTES.NOT_FOUND
];

export const isGeniusRoute = (pathname) =>
  GENIUS_ROUTE_PATHS.some((route) => pathname === route || pathname.startsWith(`${route}/`));
